<div class="report-page-root-container expense-type-summary-report-component-container ">
    <div class="page-content">
        <div class="page-header">
            <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" id="volume-analysis"
                style="width:27px">
                <path
                    d="M7,25.08H5V13a3,3,0,0,1,3-3H23v2H8a1,1,0,0,0-1,1ZM45,38H43V29H41v9H7V35H21V33H3v2H5v3H3a1,1,0,0,0-1,1v2a5,5,0,0,0,5,5H41a5,5,0,0,0,5-5V39A1,1,0,0,0,45,38ZM24,10H46V25a3,3,0,0,1-3,3H27a3,3,0,0,1-3-3Zm5,5H41V13H29Zm0,4H41V17H29Zm0,4H41V21H29ZM46,5V8H24V5a3,3,0,0,1,3-3H43A3,3,0,0,1,46,5ZM31,4H28V6h3Zm5,0H33V6h3ZM11,27a1,1,0,0,0-1-1H6a1,1,0,0,0-1,1v5h6Zm3-6a1,1,0,0,0-1,1V32h6V22a1,1,0,0,0-1-1Z"
                    data-name="33 Volume Analysis, Bar Chart, Bar Graph, Column Graph, Graphical Representation">
                </path>
            </svg>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                @if(permission.can_export || permission.can_execute){
                <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
                    [disabled]="IsDownloading">
                    <img class="download-icon" [src]="
              IsDownloading
                ? 'assets/images/animated/download/download-anim.svg'
                : 'assets/images/animated/download/download-no-anim.svg'
            " />
                    <span class="action-btn-title">Export</span>
                </button>
                }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="row">
                            <mat-form-field class="filter-year">
                                <mat-label>Year</mat-label>
                                <mat-select placeholder="Select a year" formControlName="year"
                                    (selectionChange)="onYearChange()">
                                    <mat-option *ngFor="let fy of financialYears" [value]="fy.year">
                                        {{ fy.display_year }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="row filter-row">
                            <!-- <div style="display: flex; gap: 16px; flex-wrap: wrap;"> -->
                            <!-- <div class="input-box-left"> -->
                            <mat-form-field class="filter-selection">
                                <mat-label>Filter</mat-label>
                                <mat-select formControlName="filter" (selectionChange)="onFilterChange()">
                                    <mat-option value="week">Week</mat-option>
                                    <mat-option value="month">Month</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <ng-container *ngIf="editForm.get('filter')?.value === 'week'">
                                <mat-form-field class="week-selection">
                                    <mat-label>Week From</mat-label>
                                    <mat-select formControlName="weekFrom">
                                        <mat-option *ngFor="let week of weeks" [value]="week.week_no">
                                            {{ week.displayText }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="week-selection">
                                    <mat-label>Week To</mat-label>
                                    <mat-select formControlName="weekTo">
                                        <mat-option *ngFor="let week of weeks" [value]="week.week_no">
                                            {{ week.displayText }}
                                        </mat-option>
                                    </mat-select>
                                   
                                    <mat-error
                                        *ngIf="editForm.get('weekTo')?.hasError('invalidWeekRange') &&
                                            (editForm.get('weekTo')?.touched || editForm.get('weekTo')?.dirty)">
                                        Week To must be after Week From.
                                    </mat-error>
                                </mat-form-field>
                            </ng-container>
                            <ng-container *ngIf="editForm.get('filter')?.value === 'month'">
                                <mat-form-field class="month-selection">
                                    <mat-label>Month From</mat-label>
                                    <mat-select formControlName="monthFrom">
                                        <mat-option *ngFor="let month of months" [value]="month.value">
                                            {{ month.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="month-selection">
                                    <mat-label>Month To</mat-label>
                                    <mat-select formControlName="monthTo">
                                        <mat-option *ngFor="let month of months" [value]="month.value">
                                            {{ month.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="editForm.get('monthTo')?.hasError('invalidMonthRange') &&
                                            (editForm.get('monthTo')?.touched || editForm.get('monthTo')?.dirty)">
                                        Month To must be after Month From.
                                    </mat-error>
                                </mat-form-field>
                            </ng-container>

                        </div>

                        <!-- Shop Filter Section -->
                        <div class="list-row shops">
                            <div class="header" (click)="isExpandedShop = !isExpandedShop">
                                <div class="title-container" >
                                    <span class="title">Shops</span>
                                    <span class="count" *ngIf="selectedShopSourcesCount > 0">
                                        [ {{selectedShopSourcesCount}} ]
                                    </span>
                                </div>
                                <div class="toggle-action-container">
                                    <button *ngIf="isExpandedShop" class="list-action-button"
                                        (click)="showSelectedShopOnly = !showSelectedShopOnly"
                                        [title]="showSelectedShopOnly ? 'Show All' : 'Show Selected Only'">
                                        <mat-icon>{{ showSelectedShopOnly ? 'visibility_off' : 'visibility'
                                            }}</mat-icon>
                                    </button>
                                    <button *ngIf="isExpandedShop" class="list-action-button"
                                        (click)="toggleSelectAllShop()" title="Select All/None">
                                        <mat-icon>{{ getSelectAllIconShop() }}</mat-icon>
                                    </button>
                                    <button class="list-action-button" (click)="isExpandedShop = !isExpandedShop">
                                        <mat-icon>{{ isExpandedShop ? 'expand_less' : 'expand_more' }}</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <div *ngIf="isExpandedShop" class="list">
                                <div class="item-list">
                                    <div class="content-filter">
                                        <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                                            <input matInput placeholder="Filter shops" formControlName="shopFilterAll">
                                            <button *ngIf="editForm.get('shopFilterAll')?.value" matSuffix
                                                mat-icon-button aria-label="Clear"
                                                (click)="editForm.get('shopFilterAll')?.setValue('')">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                        </mat-form-field>
                                    </div>
                                    <div class="content">
                                        <ng-container *ngFor="let item of filteredShopListData">
                                            <div class="list-item"
                                                (click)="item.selected = !item.selected; onListSelectionChange('shop')">
                                                <mat-checkbox [checked]="item.selected"
                                                    (click)="$event.stopPropagation()"
                                                    (change)="item.selected = !item.selected; onListSelectionChange('shop')">
                                                    {{ item.item.name }}
                                                </mat-checkbox>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Region Filter Section -->
                        <div class="list-row regions">
                            <div class="header" (click)="isExpandedRegion = !isExpandedRegion">
                                <div class="title-container" >
                                    <span class="title">Regions</span>
                                    <span class="count" *ngIf="selectedRegionSourcesCount > 0">
                                        [ {{selectedRegionSourcesCount}} ]
                                    </span>
                                </div>
                                <div class="toggle-action-container">
                                    <button *ngIf="isExpandedRegion" class="list-action-button"
                                        (click)="showSelectedRegionOnly = !showSelectedRegionOnly"
                                        [title]="showSelectedRegionOnly ? 'Show All' : 'Show Selected Only'">
                                        <mat-icon>{{ showSelectedRegionOnly ? 'visibility_off' : 'visibility'
                                            }}</mat-icon>
                                    </button>
                                    <button *ngIf="isExpandedRegion" class="list-action-button"
                                        (click)="toggleSelectAllRegion()" title="Select All/None">
                                        <mat-icon>{{ getSelectAllIconRegion() }}</mat-icon>
                                    </button>
                                    <button class="list-action-button" (click)="isExpandedRegion = !isExpandedRegion">
                                        <mat-icon>{{ isExpandedRegion ? 'expand_less' : 'expand_more' }}</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <div *ngIf="isExpandedRegion" class="list">
                                <div class="item-list">
                                    <div class="content-filter">
                                        <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                                            <input matInput placeholder="Filter regions"
                                                formControlName="regionFilterAll">
                                            <button *ngIf="editForm.get('regionFilterAll')?.value" matSuffix
                                                mat-icon-button aria-label="Clear"
                                                (click)="editForm.get('regionFilterAll')?.setValue('')">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                        </mat-form-field>
                                    </div>
                                    <div class="content">
                                        <ng-container *ngFor="let item of filteredRegionListData">
                                            <div class="list-item"
                                                (click)="item.selected = !item.selected; onListSelectionChange('region')">
                                                <mat-checkbox [checked]="item.selected"
                                                    (click)="$event.stopPropagation()"
                                                    (change)="item.selected = !item.selected; onListSelectionChange('region')">
                                                    {{ item.item.name }}
                                                </mat-checkbox>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>
    </div>
</div>